var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9274_4520)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7284 6.09515C10.4999 6.00054 10.2486 5.97579 10.0061 6.02402C9.76366 6.07225 9.54093 6.1913 9.36612 6.36612C9.1913 6.54093 9.07225 6.76366 9.02402 7.00614C8.97579 7.24861 9.00054 7.49995 9.09515 7.72836C9.18976 7.95676 9.34998 8.15199 9.55554 8.28934C9.7611 8.42669 10.0028 8.5 10.25 8.5H11.5V7.25C11.5 7.00277 11.4267 6.7611 11.2893 6.55554C11.152 6.34998 10.9568 6.18976 10.7284 6.09515ZM12 5.83579C11.7645 5.54436 11.4592 5.31548 11.111 5.17127C10.6999 5.00097 10.2475 4.95642 9.81105 5.04323C9.37459 5.13005 8.97368 5.34434 8.65901 5.65901C8.34434 5.97368 8.13005 6.37459 8.04323 6.81105C7.95642 7.24751 8.00097 7.6999 8.17127 8.11104C8.34157 8.52217 8.62996 8.87357 8.99997 9.12081C9.36998 9.36804 9.80499 9.5 10.25 9.5H13.75C14.195 9.5 14.63 9.36804 15 9.12081C15.37 8.87357 15.6584 8.52217 15.8287 8.11104C15.999 7.69991 16.0436 7.24751 15.9568 6.81105C15.87 6.37459 15.6557 5.97368 15.341 5.65901C15.0263 5.34434 14.6254 5.13005 14.189 5.04323C13.7525 4.95642 13.3001 5.00097 12.889 5.17127C12.5408 5.31548 12.2355 5.54436 12 5.83579ZM12.5 7.25V8.5H13.75C13.9972 8.5 14.2389 8.42669 14.4445 8.28934C14.65 8.15199 14.8102 7.95676 14.9049 7.72836C14.9995 7.49995 15.0242 7.24861 14.976 7.00614C14.9278 6.76366 14.8087 6.54093 14.6339 6.36612C14.4591 6.1913 14.2363 6.07225 13.9939 6.02402C13.7514 5.97579 13.5001 6.00054 13.2716 6.09515C13.0432 6.18976 12.848 6.34998 12.7107 6.55554C12.5733 6.7611 12.5 7.00277 12.5 7.25Z",
    fill: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9.5C6.72386 9.5 6.5 9.72386 6.5 10V11.5C6.5 11.7761 6.72386 12 7 12H17C17.2761 12 17.5 11.7761 17.5 11.5V10C17.5 9.72386 17.2761 9.5 17 9.5H7ZM5.5 10C5.5 9.17157 6.17157 8.5 7 8.5H17C17.8284 8.5 18.5 9.17157 18.5 10V11.5C18.5 12.3284 17.8284 13 17 13H7C6.17157 13 5.5 12.3284 5.5 11.5V10Z",
    fill: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.5C12.2761 8.5 12.5 8.72386 12.5 9V18H15.5C15.7652 18 16.0196 17.8946 16.2071 17.7071C16.3946 17.5196 16.5 17.2652 16.5 17V12.5C16.5 12.2239 16.7239 12 17 12C17.2761 12 17.5 12.2239 17.5 12.5V17C17.5 17.5304 17.2893 18.0391 16.9142 18.4142C16.5391 18.7893 16.0304 19 15.5 19H8.5C7.96957 19 7.46086 18.7893 7.08579 18.4142C6.71071 18.0391 6.5 17.5304 6.5 17V12.5C6.5 12.2239 6.72386 12 7 12C7.27614 12 7.5 12.2239 7.5 12.5V17C7.5 17.2652 7.60536 17.5196 7.79289 17.7071C7.98043 17.8946 8.23478 18 8.5 18H11.5V9C11.5 8.72386 11.7239 8.5 12 8.5Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9274_4520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBonus);
export default __webpack_public_path__ + "static/media/icon-bonus.cd0aaaf3b7895539ee5671ddb6cfeb05.svg";
export { ForwardRef as ReactComponent };